import React, { useState, useEffect } from 'react'
import { isSameDay } from 'date-fns'
import styled from 'styled-components'
import { DayClickEventHandler, DayPicker } from 'react-day-picker'
import moment from 'moment'
import { ko } from 'date-fns/locale'
import colors from '../../styles/colors'
import 'react-day-picker/dist/style.css'
import DeleteIcon from '../../assets/image/calendar/ic-delete.svg'

export default function SingleDates({
  selectedDates,
  setSelectedDates,
  datesToDisplay,
  setDatesToDisplay,
}) {
  const currentYear = new Date().getFullYear()
  useEffect(() => {
    setDatesToDisplay(selectedDates)
  }, [selectedDates])
  const handleDayClick = (day, modifiers) => {
    const newSelectedDays = [...datesToDisplay]
    const UTCDay = new Date(day + ' UTC')

    if (modifiers.selected) {
      const index = datesToDisplay.findIndex((datesToDisplay) =>
        isSameDay(UTCDay, new Date(datesToDisplay + ' UTC')),
      )
      newSelectedDays.splice(index, 1)
    } else {
      newSelectedDays.push(UTCDay)
    }
    setDatesToDisplay(newSelectedDays)
  }

  let footer = (
    <FooterText>* 선택한 날짜들은 최대 20개까지만 화면에 보입니다.</FooterText>
  )
  var displayDates = []

  function dateList() {
    const allYears = []
    let years = []
    if (isNaN(datesToDisplay[0])) {
      datesToDisplay.shift()
    }
    datesToDisplay.slice(0, 20).forEach(function (date) {
      allYears.push(new Date(date).getFullYear())
      years = [...new Set(allYears)]
    })

    const jsxElements = []
    const deleteParam = { selected: true }
    for (let i = 0; i < years.length; i++) {
      const year = years[i]
      jsxElements.push(
        <DateListWrapper key={year}>
          <YearWrapper>
            <YearText>{year}년 </YearText>
          </YearWrapper>
          {datesToDisplay.slice(0, 20).map(function (date, index) {
            if (year === new Date(date).getFullYear()) {
              return (
                <DateButton key={index}>
                  <DateText> {moment(date).format('MM/DD')}</DateText>
                  <DeleteIconImg
                    src={DeleteIcon}
                    onClick={() => handleDayClick(date, deleteParam)}
                  />
                </DateButton>
              )
            }
            return null
          })}
        </DateListWrapper>,
      )
    }

    return jsxElements
  }

  // function dateList() {
  //   const allYears = []
  //   let years = []
  //   // selectedDates=datesToDisplay
  //   // console.log('datesToDisplay --- ' + JSON.stringify(datesToDisplay))
  //   datesToDisplay.slice(0, 20).forEach(function (date) {
  //     allYears.push(new Date(date).getFullYear())
  //     years = [...new Set(allYears)]
  //   })
  //   const jsxElements = []

  //   for (let i = 0; i < years.length; i++) {
  //     const year = years[i]
  //     jsxElements.push(
  //       <DateListWrapper>
  //         <YearWrapper>
  //           <YearText>{year}년 </YearText>
  //         </YearWrapper>
  //         {datesToDisplay.slice(0, 20).map(function (date, index) {
  //           if (year === new Date(date).getFullYear()) {
  //             return (
  //               <DateButton key={index}>
  //                 <DateText> {moment(date).format('MM/DD')}</DateText>
  //                 <img
  //                   src={DeleteIcon}
  //                   onClick={() => handleDayClick(date, deleteParam)}
  //                   style={{
  //                     paddingLeft: '10px',
  //                   }}
  //                 />
  //               </DateButton>
  //             )
  //           }
  //           return null
  //         })}
  //       </DateListWrapper>,
  //     )
  //   }

  //   return jsxElements
  // }

  // useEffect(() => {
  //   console.log(
  //     'selectedDates-' +
  //       JSON.stringify(selectedDates) +
  //       'selectedDates length-' +
  //       selectedDates.length,
  //   )
  // }, [selectedDates])
  // useEffect(() => {
  //   console.log(
  //     'datesToDisplay-' +
  //       JSON.stringify(datesToDisplay) +
  //       'datesToDisplay length-' +
  //       datesToDisplay.length,
  //   )
  // }, [datesToDisplay])
  return (
    <>
      <Container className="d-lg-none d-xl-none">
        <DayPicker
          onDayClick={handleDayClick}
          selected={datesToDisplay}
          footer={footer}
          locale={ko}
          numberOfMonths={1}
        />
      </Container>
      <Container className="d-none  d-lg-block d-xl-block">
        <DayPicker
          onDayClick={handleDayClick}
          selected={datesToDisplay}
          footer={footer}
          locale={ko}
          numberOfMonths={2}
        />
      </Container>
      <DateListContainer>
        <DateList>{dateList()}</DateList>
      </DateListContainer>
    </>
  )
}
const DateListWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  @media ${(props) => props.theme.mobile} {
  }
`

const YearWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  /* margin-bottom: 10px; */
  gap: 10px;
  @media ${(props) => props.theme.mobile} {
    gap: 0px;
  }
`

const Container = styled.div`
  width: 578px;
  /* 푸터 글자 컨테이너 밖으로 나가는 오류 있어 수정 */
  min-height: 355px;
  /* height: 355px; */
  margin: 15px 0 16px;
  padding: 20px 10px 20px 10px;
  object-fit: contain;
  border-radius: 8px;
  border: solid 1px ${colors.G3};
  background-color: ${colors.W1};
  @media ${(props) => props.theme.tablet} {
    padding: 0px;
  }
  @media ${(props) => props.theme.mobile} {
    width: 320px;
    height: 355px;
    margin: 10px 0px;
    padding: inherit;
  }
  .modal-dialog {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .rmdp-wrapper {
    display: block !important;
  }
  .rdp {
    justify-content: center;
    display: flex;
    @media ${(props) => props.theme.mobile} {
      margin: 0;
    }
  }
  .rdp-month {
    margin: 0;
    /* margin: 0 0.5em; */
  }
  .rdrDayToday .rdrDayNumber span:after {
    background-color: ${colors.mainG} !important;
  }
  .selectedDate {
    background-color: ${colors.mainG} !important;
    border-radius: 1.333em;
    color: ${colors.W1};
  }

  .rdp-day_today {
    color: ${colors.mainG};
    text-decoration: underline 2px;
  }

  .selectedDate span {
    color: ${colors.W1};
  }
  .rdp-day_selected,
  .rdp-day_selected:focus-visible,
  .rdp-day_selected:hover {
    color: ${colors.W1};
    opacity: 1;
    background-color: ${colors.mainG} !important;
  }

  .rdp-button:hover:not([disabled]):not(.rdp-day_selected) {
    background-color: ${colors.lightG};
  }
  .rdrCalendarWrapper:not(.rdrDateRangeWrapper)
    .rdrDayHovered
    .rdrDayNumber:after {
    content: '';
    border: 1px solid transparent !important;
    border-radius: 1.3em;
    position: absolute;
    top: -2px;
    bottom: -2px;
    left: 0px;
    right: 0px;
    background: transparent;
  }
  .rdrDayStartPreview,
  .rdrDayInPreview,
  .rdrDayEndPreview {
    background: ${colors.W1} !important;
    position: absolute;
    top: 3px;
    left: 0px;
    right: 0px;
    bottom: 3px;
    pointer-events: none;
    border: 0px solid transparent !important;
    z-index: 1;
  }
  .rdrDayNumber:hover {
    border: 1px solid ${colors.mainG} !important;
    border-radius: 1.333em !important;
  }
`

const DeleteIconImg = styled.img`
  padding-left: 10px;
  @media ${(props) => props.theme.mobile} {
  }
`
const YearText = styled.div`
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${colors.G4};
  @media ${(props) => props.theme.mobile} {
    font-size: 17px;
  }
`
const DateButton = styled.div`
  width: 100px;
  height: 30px;
  border-radius: 15px;
  background-color: ${colors.mainG};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2px;
  @media ${(props) => props.theme.mobile} {
    width: 95px;
    height: 30px;
    margin: 7px 6px;
  }
`
const FooterText = styled.p`
  font-size: 12px;
  padding-top: 20px;
`
const DateText = styled.span`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${colors.W1};
`
const DateListContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: cemter;
  padding: 10px 10px 0px;
  @media ${(props) => props.theme.mobile} {
    padding: 20px 0px 0px 0px;
  }
`
const DateList = styled.div`
  width: 632px;
  @media ${(props) => props.theme.mobile} {
  }
`
